import { Injectable } from '@angular/core';
import { AscendAddendumEnums } from '../classes/ascendAddendumEnums';
import { CardiacAddendum2022Enums } from '../classes/cardiacAddendum2022Enums';
import { CardiacOldAddendumEnums } from '../classes/cardiacOldAddendumEnums';
import { CovidAddendumEnums } from '../classes/covidAddendumEnums';
import { DeviceEnums } from '../classes/deviceEnums';
import { ECPRAddendum2020Enums } from '../classes/ecprAddendum2020Enums';
import { ECPROldAddendumEnums } from '../classes/ecprOldAddendumEnums';
import { InfectionEnums } from '../classes/infectionEnums';
import { SeverityScoresEnums } from '../classes/severityScoresEnums';
import { TraumaAddendumEnums } from '../classes/traumaAddendumEnums';

Injectable()
export class EnumService {

  constructor() { }


  deviceEnumsSet: boolean = false;
  ECPRAddendum2020Enums: ECPRAddendum2020Enums;
  CardiacAddendumEnums: CardiacAddendum2022Enums;
  CardiacOldAddendumEnums: CardiacOldAddendumEnums;
  CovidAddendumEnums: CovidAddendumEnums;
  SeverityScoresEnums: SeverityScoresEnums;
  TraumaAddendumEnums: TraumaAddendumEnums;
  ECPROldAddendumEnums: ECPROldAddendumEnums;
  AscendAddendumEnums: AscendAddendumEnums;


  enumGraphs = [
    { name: 'Your Overall Runs', value: 0 },
    { name: 'Volume – Children (Pediatric & Neonatal)', value: 1 },
    { name: 'Volume – Adult', value: 2 }
  ];

  //Settings
  enumDatePickerType = [
    { name: 'Popup date picker', value: 1 },
    { name: 'Drop down date picker', value: 2 },
    { name: 'Manual entry and popup date picker', value: 3 }
  ];
  enumUnitSystem = [
    { name: 'US', value: 1 },
    { name: 'SI', value: 0 }
  ];

  enumFormatOptions = [
    { name: 'Default culture 12 hour format', value: 1 },
    { name: 'Default culture 24 hour format', value: 2 },
    { name: 'en-US culture 12 hour format', value: 3 },
    { name: 'en-US culture 24 hour format', value: 4 },
  ];

  /////////////////////////////////////////

  enumForceViewModeSections = [
    { name: 'procedures' },
    { name: 'cannulations' },
    { name: 'infections' },
    { name: 'diagnoses' },
    { name: 'complications' },
    { name: 'addeda' },
    { name: 'main' }//main addenda section
  ];

  enumScanDeviceTypes = [
    { name: 'Membrane Lung', value: 1 },
    { name: 'Blood Pump', value: 2 },
    { name: 'Heat Exchanger', value: 3 },
    { name: 'Hemofilter', value: 4 },
    { name: 'Temperature Regulation', value: 5 },
    { name: 'Cannula', value: 6 },
  ];
  //Cannulations
  enumCannulationPurposes = [
    { name: 'Drainage', value: 1 },
    { name: 'Return', value: 2 },
    { name: 'Both drainage and return', value: 3 },
    { name: 'Distal perfusion catheter(DPC)', value: 4 }
  ];
  enumCannulationSites: any;
  /////////////////////////////////////////
  //////////////////////////////////////////
  //CPTProcedures
  enumProceduresEstimated = [
    { name: 'Yes', value: true },
    { name: 'No', value: false }
  ];
  /////////////////////////////////////////
  enumComplicationCodes: any;

  MLReplacementCodes: any;
  BPReplacementCodes: any;
  CReplacementCodes: any;
  ConsoleReplacementCodes: any;


  ///////////PatientInfo
  enumSex = [
    { name: 'Unknown', value: 0 },
    { name: 'Male', value: 1 },
    { name: 'Female', value: 2 }
  ];
  enumCDHYesNoUnknown = [
    { name: 'Yes', value: 1 },
    { name: 'No', value: 0 },
    { name: 'Unknown', value: -1 }
  ];
  enumCannulaLigatedRepaired = [
    { name: 'Repaired', value: 1 },
    { name: 'Ligated', value: 0 },
    { name: 'None', value: -1 }
  ];
  enumCDHSide = [
    { name: 'Unknown', value: 0 },
    { name: 'Left', value: 1 },
    { name: 'Right', value: 2 },
    { name: 'Bilateral', value: 3 },
  ];
  enumCDHRepair = [
    { name: 'None', value: 0 },
    { name: 'PreECLS', value: 1 },
    { name: 'OnECLS', value: 2 },
    { name: 'PostECLS', value: 3 },
  ];
  enumCDHRepairYesNo = [
    { name: 'No', value: 0 },
    { name: 'Yes', value: 1 },
  ];

  enumRace = [
    { name: 'Unknown', value: 0 },
    { name: 'Asian', value: 1 },
    { name: 'Black', value: 2 },
    { name: 'Hispanic', value: 3 },
    { name: 'White', value: 4 },
    { name: 'Middle Eastern or North African', value: 5 },
    { name: 'Native American', value: 6 },
    { name: 'Native Pacific Islander', value: 7 },
    { name: 'Other', value: 9 }
  ];

  enumDelivery = [
    { name: 'Unknown', value: 0 },
    { name: 'Vaginal', value: 1 },
    { name: 'Emergency C-Section', value: 2 },
    { name: 'Elective C-Section', value: 3 }
  ];
  //////////////////////////////////////////

  //RunInfo, AddPatient, AddRun
  enumSupportTypes = [
    { name: 'Pulmonary', value: 1 },
    { name: 'Cardiac', value: 2 },
    { name: 'ECPR', value: 3 }
  ];
  enumCoVID = [
    { name: 'COVID19 confirmed by testing', value: 1 },
    { name: 'COVID19 suspected but NO testing', value: 2 },
    { name: 'No clinical suspicion of COVID19 (and no testing)', value: 3 },
    { name: 'COVID19 confirmed negative', value: 4 }
  ];
  enumMisC = [
    { name: 'Clinically Suspected/Confirmed', value: 1 },
    { name: 'Not Clinically Suspected', value: 2 }
  ];
  enumIntubation = [
    { name: 'Yes date/time known', value: 1 },
    { name: 'Pre-Existing invasive ventilation', value: 2 },
    { name: 'Yes date/time unknown', value: 3 },
    { name: 'Yes date/time estimate', value: 4 },
    { name: 'No', value: 0 }
  ];
  enumInvasiveVentilation = [
    { name: 'New date/time known', value: 1 },
    { name: 'Pre-existing invasive ventilation', value: 2 },
    { name: 'Yes date/time unknown', value: 3 },
    { name: 'Yes date/time estimate', value: 4 },
    { name: 'No', value: 0 }
  ];
  ///
  ///////////PreECLSSupport
  enumPatientTransported = [
    { name: 'Transported on ECMO', value: 1 },
    { name: 'Transported not on ECMO', value: 0 },
    { name: 'Not transported', value: 2 },
    { name: 'Unknown', value: -1 }
  ];
  //////////////////////////////////////////
  enumYesNoUnknown = [
    { name: 'Yes', value: 1 },
    { name: 'No', value: 0 },
    { name: 'Unknown', value: -1 }
  ];
  //////////////////////////////////////////
  ///////////Pre/ECLS Assessment
  enumVentTypes = [
    { name: 'Other', value: 0 },
    { name: 'Conventional', value: 1 },
    { name: 'HFO', value: 2 },
    { name: 'OtherHFV', value: 3 },
    { name: 'No Ventilator', value: 4 }
  ];
  enumPreSupportICU = [
    { name: 'Neonatal ICU', value: 0 },
    { name: 'Pediatric ICU', value: 1 },
    { name: 'Pediatric cardiac ICU', value: 2 },
    { name: 'Adult Medicine ICU', value: 3 },
    { name: 'Adult Surgical ICU', value: 4 },
    { name: 'Adult Cardiac ICU', value: 5 },
    { name: 'Adult Cardiovascular ICU', value: 6 },
    { name: 'Mixed ICU', value: 7 },
    { name: 'ECLS ICU', value: 8 },
    { name: 'Emergency Department', value: 9 },
    { name: 'Operating Room/Cath Lab', value: 10 },
    { name: 'Burn ICU', value: 11 }
  ];
  enumMobilizationLevels = [
    { name: '0 Nothing (lying in bed)', value: 0, title: 'Passively rolled or passively exercised by staff, but not actively moving' },
    { name: '1 Sitting in bed, exercises in bed', value: 1, title: 'Any activity in bed, including rolling, bridging, active exercises, cycle ergometry and active assisted exercises; not moving out of bed or over the edge of the bed' },
    { name: '2 Passively moved to chair (no standing) ', value: 2, title: 'Hoist, passive lift or slide transfer to the chair, with no standing or sitting on the edge of the bed' },
    { name: '3 Sitting over edge of bed', value: 3, title: 'May be assisted by staff, but involves actively sitting over the side of the bed with some trunk control' },
    { name: '4 Standing ', value: 4, title: 'Weight bearing through the feet in the standing position, with or without assistance. This may include use of a standing lifter device or tilt table' },
    { name: '5 Transferring bed to chair', value: 5, title: ' Able to step or shuffle through standing to the chair. This involves actively transferring weight from one leg to another to move to the chair. If the patient has been stood with the assistance of a medical device, they must step to the chair (not included if the patient is wheeled in a standing lifter device)' },
    { name: '6 Marching on spot (at bedside)', value: 6, title: 'Able to walk on the spot by lifting alternate feet (must be able to step at least 4 times, twice on each foot), with or without assistance' },
    { name: '7 Walking with assistance of 2 or more people', value: 7, title: 'Walking away from the bed/chair by at least 5 m (5 yards) assisted by 2 or more people' },
    { name: '8 Walking with assistance of 1 person', value: 8, title: 'Walking away from the bed/chair by at least 5 m (5 yards) assisted by 1 person' },
    { name: '9 Walking independently with a gait aid', value: 9, title: 'Walking away from the bed/chair by at least 5 m (5 yards) with a gait aid, but no assistance from another person. In a wheelchair bound person, this activity level includes wheeling the chair independently 5 m (5 years) away from the bed/chair' },
    { name: '10 Walking independently without a gait aid', value: 10, title: 'Walking away from the bed/chair by at least 5 m (5 yards) without a gait aid or assistance from another person' }
  ];
  enumYesNo = [
    { name: 'Yes', value: 1 },
    { name: 'No', value: 0 }
  ];
  //////////////////////////////////////////
  //Equipment history devices
  enumConcurrentDeviceNames = [
    { name: 'Initial', value: 0 },
    { name: 'Second Concurrent', value: 1 },
    { name: 'Third Concurrent', value: 2 },
    { name: 'Fourth Concurrent', value: 3 },
    { name: 'Fifth Concurrent', value: 4 },
    { name: 'Sixth Concurrent', value: 5 },
    { name: 'Seventh Concurrent', value: 6 },
    { name: 'Eqighth Concurrent', value: 7 },
    { name: 'Ninth Concurrent', value: 8 },
    { name: 'Tenth Concurrent', value: 9 },
    { name: 'Eleventh Concurrent', value: 10 },
    { name: 'Twelveth Concurrent', value: 11 }
  ];
  ///////////Modes/RunDetails
  enumRunModes = [
    { name: 'VA', value: 1, disabled: false },
    { name: 'VV', value: 2, disabled: false },
    { name: 'VVA', value: 3, disabled: false },
    { name: 'AVCO2R', value: 4, disabled: false },
    { name: 'VVECCO2R', value: 5, disabled: false },
    { name: 'VP', value: 6, disabled: false },
    { name: 'Unknown', value: 0, disabled: true },
    { name: 'Other', value: 9, disabled: false }
  ];

  enumInitialDeviceOrderName = [
    { name: 'Initial', value: 0 },
    { name: 'Second concurrent', value: 1 },
    { name: 'Third concurrent', value: 2 },
    { name: 'Fourth concurrent', value: 3 },
    { name: 'Fifth concurrent', value: 4 },
    { name: 'Sixth concurrent', value: 5 },
    { name: 'Seventh concurrent', value: 6 },
    { name: 'Eqighth concurrent', value: 7 },
    { name: 'Ninth concurrent', value: 8 },
    { name: 'Tenth concurrent', value: 9 },
    { name: 'Eleventh concurrent', value: 10 },
    { name: 'Twelveth concurrent', value: 11 }
  ];

  enumYesNoBoolean = [
    { name: 'Yes', value: true },
    { name: 'No', value: false }
  ];

  InfectionEnums: InfectionEnums;
  DeviceEnums: DeviceEnums;

  enumSystemOnlineOffline = [
    { name: 'Online', value: false },
    { name: 'Offline', value: true }
  ];

  enumExtubated = [
    { name: 'Endotracheally (oral and nasal) extubated', value: 0 },
    { name: 'N/A Tracheostomy (including Tracheostomy decannulation)', value: 1 },
    { name: 'N/A transferred intubated', value: 2 },
    { name: 'N/A still intubated at time of death', value: 3 },
    { name: 'N/A other', value: 4 },
  ];
  enumCannulaRepair = [
    { name: 'None', value: 0 },
    { name: 'Common Carotid Artery', value: 1 },
    { name: 'Internal Jugular Vein', value: 2 },
    { name: 'Carotid and Jugular', value: 3 },
    { name: 'Other', value: 4 }
  ];
  enumDiscontinuation = [
    { name: 'Unknown', value: 0 },
    { name: 'Expected Recovery', value: 1 },
    { name: 'Poor Prognosis Followed by Death', value: 2 },
    { name: 'Resource Limitation', value: 6 },
    { name: 'VAD', value: 10 },
    { name: 'Pumpless Lung Assist (PA to LA)', value: 11 },
    { name: 'Heart Tx', value: 12 },
    { name: 'Lung Tx', value: 13 },
    { name: 'Heart/Lung Tx', value: 14 },
    { name: 'Complication', value: 15 },
    { name: 'Poor Prognosis Followed by Unexpected Survival', value: 16 }
  ];
  enumDischargedAlive = [
    { name: 'No', value: 0 },
    { name: 'Yes', value: 1 },
    { name: 'On ECMO', value: 2 }
  ];
  enumDischargeLocation = [
    { name: 'Home', value: 1, disabled: false },
    { name: 'Other, Unknown', value: 2, disabled: false },
    { name: 'Transferred to another hospital', value: 3, disabled: false },
    { name: 'Transfer to LTAC or Rehab', value: 4, disabled: true },
    { name: 'Transfer to hospice', value: 5, disabled: false },
    { name: 'Transfer to LTAC', value: 6, disabled: false },
    { name: 'Transfer to Rehab', value: 7, disabled: false }
  ];
  //ECPR 2020
  //enumECPRAntecedentEventCodes: any;
  //enumCMConditionCodes: any;
  //enumECPROOHCACodes: any;
  //enumECPR2020CompressionMethodsUsed: any;
  //enumECPR2020MedicationCodes: any;
  //enumECPR2020OiDuringCPAcodes: any;
  
}
